<template>
  <div class="modal fade" id="become-an-affiliate-success" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div :class="[{'zh-style' : language === 'zh'}, 'modal-dialog']" role="document">
      <div class="modal-content text-center">

        <div class="modal-header">
          <button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span>
              <svg class="icon">
                <use xlink:href="#icon-close"></use>
              </svg>
          </span>
          </button>
        </div>

        <div class="modal-body">
          <p>{{ $t('thanksInfo') }}<br>{{ $t('successNotice') }}<span>iplexservice@gmail.com</span></p>
        </div>

        <div class="modal-footer">
          <router-link to="/" data-dismiss="modal" aria-label="Close">{{ $t('sure') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import locales from './lang'

  export default {
    name: 'become-affiliate-success-modal',
    computed: {
      language() {
        return this.$store.state.currentLang
      }
    },
    locales,
    mounted() {
      $('#become-an-affiliate-success').modal('show')
      let _this = this
      $('#become-an-affiliate-success').on('hidden.bs.modal', function () {
        _this.$router.push('/')
      })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/reset-modal";


  .modal-dialog {
    @include modal-dialog($height:4.4rem, $phone-height: 4.9rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.45rem) 0 0 -45% !important;
    }
  }

  .zh-style {
    @include modal-dialog($height:3.5rem, $phone-height: 4.06rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.03rem) 0 0 -45% !important;
    }
  }

  .modal-header {
    min-height: .2rem;
  }

  .modal-body {
    font-size: .16rem;
    color: #333;
    letter-spacing: 0.71px;
    line-height: .28rem;
    padding: .2rem .2rem .6rem .2rem;
    @media (max-width: 767px) {
      padding: .2rem 0 .6rem 0;
    }
    span {
      font-size: .16rem;
      color: #416CF8;
      letter-spacing: 0.71px;
      line-height: .28rem;
    }
  }

  .modal-footer {
    text-align: center;
    a {
      display: inline-block;
      @include modal-button();
      margin-bottom: .2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?72d7104e